import { _Types, getServerData } from "@reactivated";

import {
    getDocument,
    getJSONScriptData,
    getWindow,
} from "@thelabnyc/thelabui/src/utils/dom";

export const IS_PUPPETEER = (() => {
    const _window = getWindow();
    return !!(
        _window && _window.navigator.userAgent.includes("HeadlessChrome")
    );
})();

export type ReactivatedContext = Readonly<_Types["Context"]>;

let _context: ReactivatedContext | null = null;

export const getReactivatedContext = (): ReactivatedContext | null => {
    if (!_context) {
        const window = getWindow();
        const document = getDocument();
        if (
            window &&
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            (window as any).__PRELOADED_CONTEXT__
        ) {
            _context = getServerData().context;
        } else if (document) {
            _context = getJSONScriptData(
                "thelabui-react-context",
            ) as ReactivatedContext | null;
        }
    }
    return _context;
};
